import {
	pageValueEnum
} from './config/enum.js'
const {
	globalConfig,
	menu,
	home,
	detail,
	classify,
	pcNav,
	phoneNav,
	pcFooter,
	phoneFooter,
	globalDialog
} = pageValueEnum
export default {
	left: {
		menu: [{
				pageValue: globalConfig,
				name: "全局",
				iconComponent: 'elIcon', // 图标组件 1 el  2 vant
				iconName: "el-icon-setting",
				selectRule: [globalConfig]
			},
			{
				pageValue: menu,
				name: "菜单",
				iconComponent: 'elIcon',
				iconName: "el-icon-s-operation",
				selectRule: [menu]
			},
			{
				pageValue: home,
				name: "首页",
				iconComponent: 'vantIcon',
				iconName: "wap-home-o",
				selectRule: [home]
			},
			{
				pageValue: classify,
				name: "商品分类",
				iconComponent: 'vantIcon',
				iconName: "apps-o",
				selectRule: [classify]
			},
			{
				pageValue: detail,
				name: "商品详情",
				iconComponent: 'elIcon',
				iconName: "el-icon-reading",
				selectRule: [detail]
			},
			{
				pageValue: pcNav,
				name: "页眉",
				iconComponent: 'vantIcon',
				iconName: "ascending",
				selectRule: [pcNav, phoneNav]
			},
			{
				pageValue: pcFooter,
				name: "页脚",
				iconComponent: 'vantIcon',
				iconName: "descending",
				selectRule: [pcFooter, phoneFooter]
			},
			{
				pageValue: globalDialog,
				name: "弹窗",
				iconComponent: 'elIcon',
				iconName: "el-icon-set-up",
				selectRule: [globalDialog]
			},
		]
	},
	center: {
		page: [{
				type: 'pcNav',
				filed: 'navList',
				equipment: 'pc',
				pageValue: pcNav
			},
			{
				type: 'phoneNav',
				filed: 'navPhoneList',
				equipment: 'phone',
				pageValue: phoneNav
			},
			{
				type: 'pcFooter',
				filed: 'footerList',
				equipment: 'pc',
				pageValue: pcFooter
			},
			{
				type: 'phoneFooter',
				filed: 'footerPhoneList',
				equipment: 'phone',
				pageValue: phoneFooter
			},
			{
				type: 'home',
				filed: 'homeList',
				equipment: 'pc',
				pageValue: home
			},
			{
				type: 'detail',
				filed: 'detailList',
				equipment: 'pc',
				pageValue: detail,
				// 默认加载组件
				loadCmp: ['wmDetail'],
			},
			{
				type: 'classifyList',
				filed: 'classifyList',
				equipment: 'pc',
				pageValue: classify,
				// 默认加载组件
				loadCmp: ['wmClassify'],
			},
			{
				type: 'globalDialogList',
				filed: 'globalDialogList',
				equipment: 'pc',
				pageValue: globalDialog,
			}
		]
	}
}